import React from "react";
import { Play } from "@phosphor-icons/react";

const VIDEOS = [
  {
    src: "https://rutube.ru/play/embed/3bcbcfa4362233a496378a19b80d833b/",
    title: "InBoost AI Engine — обзор платформы",
    label: "Обзор",
    testid: "video-1",
  },
  {
    src: "https://rutube.ru/play/embed/7551871a26822f5a956ca38601d185b2/",
    title: "InBoost AI Engine — техническая демонстрация",
    label: "Демонстрация",
    testid: "video-2",
  },
];

export const Videos = () => {
  return (
    <section id="videos" data-testid="videos-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-8 mb-12">
          <div className="lg:col-span-7">
            <div className="mono text-xs uppercase tracking-[0.22em] text-brand-cyan mb-3">
              / 06 — Видео
            </div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              Платформа{" "}
              <span className="text-brand-cyan">в действии.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 self-end">
            <p className="text-muted text-sm leading-relaxed">
              Запись обзорного питча и техническая демонстрация InBoost AI Engine —
              как RL-агент перераспределяет нагрузку GPU в реальном времени.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {VIDEOS.map((v) => (
            <div
              key={v.testid}
              data-testid={v.testid}
              className="group glass rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="flex items-center justify-between px-5 py-3 border-b border-ink-text/8">
                <div className="flex items-center gap-2">
                  <Play size={14} weight="fill" className="text-brand-cyan" />
                  <span className="mono text-[10px] uppercase tracking-[0.22em] text-brand-cyan">
                    {v.label}
                  </span>
                </div>
                <div className="flex items-center gap-1.5">
                  <span className="w-1.5 h-1.5 rounded-full bg-success animate-pulse" />
                  <span className="mono text-[10px] text-muted">RUTUBE</span>
                </div>
              </div>
              <div className="relative aspect-video bg-[#0A0F1E]">
                <iframe
                  src={v.src}
                  title={v.title}
                  className="absolute inset-0 w-full h-full"
                  style={{ border: "none" }}
                  allow="clipboard-write; autoplay"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Videos;
